import { observer } from "mobx-react-lite";

import { useAuthContext } from "src/auth";

import { AccountMenuContent } from "./AccountMenuContent";
import { AccountMenuWithOrganizations } from "./AccountMenuWithOrganizations";

interface AccountMenuProps {
  sidebar?: boolean;
}

export const AccountMenu = observer(function AccountMenu(
  props: AccountMenuProps,
) {
  const authContext = useAuthContext();
  const { canAccessOrganizations, canCreateOrganizations } =
    authContext.store.authenticatedData.entitlements;

  if (!canAccessOrganizations) {
    return (
      <AccountMenuContent
        canCreateOrganizations={false}
        organizations={[]}
        sidebar={props.sidebar}
      />
    );
  }

  return (
    <AccountMenuWithOrganizations
      canCreateOrganizations={canCreateOrganizations}
      sidebar={props.sidebar}
    />
  );
});
